import { msg } from '@lingui/core/macro';
import type { I18n, MessageDescriptor } from '@lingui/core';

// ---------------------------------------------------------------------------
// Registry — one msg() per seed product group name.
// The `context` param adds msgctxt to PO files for DeepL disambiguation.
// ---------------------------------------------------------------------------

export const productGroupMessages: Record<string, MessageDescriptor> = {
  '1% Milk': msg({ message: `1% Milk`, context: 'product group name' }),
  '2% Milk': msg({ message: `2% Milk`, context: 'product group name' }),
  'All-Purpose Cleaner': msg({ message: `All-Purpose Cleaner`, context: 'product group name' }),
  'All-Purpose Flour': msg({ message: `All-Purpose Flour`, context: 'product group name' }),
  'Almond Butter': msg({ message: `Almond Butter`, context: 'product group name' }),
  'Almond Milk': msg({ message: `Almond Milk`, context: 'product group name' }),
  Almonds: msg({ message: `Almonds`, context: 'product group name' }),
  'Aluminum Foil': msg({ message: `Aluminum Foil`, context: 'product group name' }),
  'Apple Cider Vinegar': msg({ message: `Apple Cider Vinegar`, context: 'product group name' }),
  'Apple Juice': msg({ message: `Apple Juice`, context: 'product group name' }),
  Apples: msg({ message: `Apples`, context: 'product group name' }),
  Asparagus: msg({ message: `Asparagus`, context: 'product group name' }),
  Avocados: msg({ message: `Avocados`, context: 'product group name' }),
  'Baby Food': msg({ message: `Baby Food`, context: 'product group name' }),
  'Baby Formula': msg({ message: `Baby Formula`, context: 'product group name' }),
  'Baby Spinach': msg({ message: `Baby Spinach`, context: 'product group name' }),
  Bacon: msg({ message: `Bacon`, context: 'product group name' }),
  Bagels: msg({ message: `Bagels`, context: 'product group name' }),
  Baguette: msg({ message: `Baguette`, context: 'product group name' }),
  'Baking Powder': msg({ message: `Baking Powder`, context: 'product group name' }),
  'Baking Soda': msg({ message: `Baking Soda`, context: 'product group name' }),
  Bananas: msg({ message: `Bananas`, context: 'product group name' }),
  'Bar Soap': msg({ message: `Bar Soap`, context: 'product group name' }),
  'Basmati Rice': msg({ message: `Basmati Rice`, context: 'product group name' }),
  Batteries: msg({ message: `Batteries`, context: 'product group name' }),
  'BBQ Sauce': msg({ message: `BBQ Sauce`, context: 'product group name' }),
  'Beef Broth': msg({ message: `Beef Broth`, context: 'product group name' }),
  'Beef Jerky': msg({ message: `Beef Jerky`, context: 'product group name' }),
  'Beef Roast': msg({ message: `Beef Roast`, context: 'product group name' }),
  'Beef Steak': msg({ message: `Beef Steak`, context: 'product group name' }),
  Beer: msg({ message: `Beer`, context: 'product group name' }),
  'Bell Peppers': msg({ message: `Bell Peppers`, context: 'product group name' }),
  'Black Tea': msg({ message: `Black Tea`, context: 'product group name' }),
  Blueberries: msg({ message: `Blueberries`, context: 'product group name' }),
  'Body Wash': msg({ message: `Body Wash`, context: 'product group name' }),
  'Bread Crumbs': msg({ message: `Bread Crumbs`, context: 'product group name' }),
  'Bread Flour': msg({ message: `Bread Flour`, context: 'product group name' }),
  Brisket: msg({ message: `Brisket`, context: 'product group name' }),
  Broccoli: msg({ message: `Broccoli`, context: 'product group name' }),
  'Brown Rice': msg({ message: `Brown Rice`, context: 'product group name' }),
  'Brown Sugar': msg({ message: `Brown Sugar`, context: 'product group name' }),
  'Brussels Sprouts': msg({ message: `Brussels Sprouts`, context: 'product group name' }),
  Butter: msg({ message: `Butter`, context: 'product group name' }),
  'Butternut Squash': msg({ message: `Butternut Squash`, context: 'product group name' }),
  'Caesar Dressing': msg({ message: `Caesar Dressing`, context: 'product group name' }),
  'Canned Black Beans': msg({ message: `Canned Black Beans`, context: 'product group name' }),
  'Canned Chicken': msg({ message: `Canned Chicken`, context: 'product group name' }),
  'Canned Chickpeas': msg({ message: `Canned Chickpeas`, context: 'product group name' }),
  'Canned Corn': msg({ message: `Canned Corn`, context: 'product group name' }),
  'Canned Green Beans': msg({ message: `Canned Green Beans`, context: 'product group name' }),
  'Canned Kidney Beans': msg({ message: `Canned Kidney Beans`, context: 'product group name' }),
  'Canned Peas': msg({ message: `Canned Peas`, context: 'product group name' }),
  'Canned Ravioli': msg({ message: `Canned Ravioli`, context: 'product group name' }),
  'Canned Salmon': msg({ message: `Canned Salmon`, context: 'product group name' }),
  'Canned Soup': msg({ message: `Canned Soup`, context: 'product group name' }),
  'Canned Tomatoes': msg({ message: `Canned Tomatoes`, context: 'product group name' }),
  'Canned Tuna': msg({ message: `Canned Tuna`, context: 'product group name' }),
  Carrots: msg({ message: `Carrots`, context: 'product group name' }),
  Cashews: msg({ message: `Cashews`, context: 'product group name' }),
  Catfish: msg({ message: `Catfish`, context: 'product group name' }),
  Cauliflower: msg({ message: `Cauliflower`, context: 'product group name' }),
  Celery: msg({ message: `Celery`, context: 'product group name' }),
  Cereal: msg({ message: `Cereal`, context: 'product group name' }),
  'Cereal Bars': msg({ message: `Cereal Bars`, context: 'product group name' }),
  'Cheddar Cheese': msg({ message: `Cheddar Cheese`, context: 'product group name' }),
  'Cheese Puffs': msg({ message: `Cheese Puffs`, context: 'product group name' }),
  Cherries: msg({ message: `Cherries`, context: 'product group name' }),
  'Cherry Tomatoes': msg({ message: `Cherry Tomatoes`, context: 'product group name' }),
  'Chicken Breasts': msg({ message: `Chicken Breasts`, context: 'product group name' }),
  'Chicken Broth': msg({ message: `Chicken Broth`, context: 'product group name' }),
  'Chicken Strips': msg({ message: `Chicken Strips`, context: 'product group name' }),
  'Chicken Thighs': msg({ message: `Chicken Thighs`, context: 'product group name' }),
  'Chicken Wings': msg({ message: `Chicken Wings`, context: 'product group name' }),
  'Chocolate Bar': msg({ message: `Chocolate Bar`, context: 'product group name' }),
  'Chocolate Milk': msg({ message: `Chocolate Milk`, context: 'product group name' }),
  Clams: msg({ message: `Clams`, context: 'product group name' }),
  'Coconut Milk (Can)': msg({ message: `Coconut Milk (Can)`, context: 'product group name' }),
  'Coconut Milk Beverage': msg({ message: `Coconut Milk Beverage`, context: 'product group name' }),
  Cod: msg({ message: `Cod`, context: 'product group name' }),
  Coffee: msg({ message: `Coffee`, context: 'product group name' }),
  'Coffee Pods': msg({ message: `Coffee Pods`, context: 'product group name' }),
  Cola: msg({ message: `Cola`, context: 'product group name' }),
  Conditioner: msg({ message: `Conditioner`, context: 'product group name' }),
  Cookies: msg({ message: `Cookies`, context: 'product group name' }),
  Corn: msg({ message: `Corn`, context: 'product group name' }),
  'Corn Tortillas': msg({ message: `Corn Tortillas`, context: 'product group name' }),
  'Cottage Cheese': msg({ message: `Cottage Cheese`, context: 'product group name' }),
  Crab: msg({ message: `Crab`, context: 'product group name' }),
  Crackers: msg({ message: `Crackers`, context: 'product group name' }),
  'Cream Cheese': msg({ message: `Cream Cheese`, context: 'product group name' }),
  'Cream Corn': msg({ message: `Cream Corn`, context: 'product group name' }),
  Croissants: msg({ message: `Croissants`, context: 'product group name' }),
  Cucumbers: msg({ message: `Cucumbers`, context: 'product group name' }),
  'Deli Ham': msg({ message: `Deli Ham`, context: 'product group name' }),
  'Deli Turkey': msg({ message: `Deli Turkey`, context: 'product group name' }),
  Deodorant: msg({ message: `Deodorant`, context: 'product group name' }),
  'Diet Cola': msg({ message: `Diet Cola`, context: 'product group name' }),
  'Dijon Mustard': msg({ message: `Dijon Mustard`, context: 'product group name' }),
  'Dinner Rolls': msg({ message: `Dinner Rolls`, context: 'product group name' }),
  'Dish Soap': msg({ message: `Dish Soap`, context: 'product group name' }),
  'Dishwasher Pods': msg({ message: `Dishwasher Pods`, context: 'product group name' }),
  Donuts: msg({ message: `Donuts`, context: 'product group name' }),
  'Dried Black Beans': msg({ message: `Dried Black Beans`, context: 'product group name' }),
  'Dried Lentils': msg({ message: `Dried Lentils`, context: 'product group name' }),
  'Egg Noodles': msg({ message: `Egg Noodles`, context: 'product group name' }),
  'Egg Whites': msg({ message: `Egg Whites`, context: 'product group name' }),
  Eggs: msg({ message: `Eggs`, context: 'product group name' }),
  'Energy Drinks': msg({ message: `Energy Drinks`, context: 'product group name' }),
  'English Muffins': msg({ message: `English Muffins`, context: 'product group name' }),
  'Fabric Softener': msg({ message: `Fabric Softener`, context: 'product group name' }),
  'Facial Tissues': msg({ message: `Facial Tissues`, context: 'product group name' }),
  'French Bread': msg({ message: `French Bread`, context: 'product group name' }),
  'Frozen Berries': msg({ message: `Frozen Berries`, context: 'product group name' }),
  'Frozen Broccoli': msg({ message: `Frozen Broccoli`, context: 'product group name' }),
  'Frozen Burritos': msg({ message: `Frozen Burritos`, context: 'product group name' }),
  'Frozen Chicken Nuggets': msg({
    message: `Frozen Chicken Nuggets`,
    context: 'product group name',
  }),
  'Frozen Cod': msg({ message: `Frozen Cod`, context: 'product group name' }),
  'Frozen Corn': msg({ message: `Frozen Corn`, context: 'product group name' }),
  'Frozen Dumplings': msg({ message: `Frozen Dumplings`, context: 'product group name' }),
  'Frozen Edamame': msg({ message: `Frozen Edamame`, context: 'product group name' }),
  'Frozen Fish Sticks': msg({ message: `Frozen Fish Sticks`, context: 'product group name' }),
  'Frozen French Fries': msg({ message: `Frozen French Fries`, context: 'product group name' }),
  'Frozen Fruit': msg({ message: `Frozen Fruit`, context: 'product group name' }),
  'Frozen Meals': msg({ message: `Frozen Meals`, context: 'product group name' }),
  'Frozen Pancakes': msg({ message: `Frozen Pancakes`, context: 'product group name' }),
  'Frozen Peas': msg({ message: `Frozen Peas`, context: 'product group name' }),
  'Frozen Pizza': msg({ message: `Frozen Pizza`, context: 'product group name' }),
  'Frozen Shrimp': msg({ message: `Frozen Shrimp`, context: 'product group name' }),
  'Frozen Vegetables Mix': msg({ message: `Frozen Vegetables Mix`, context: 'product group name' }),
  'Frozen Waffles': msg({ message: `Frozen Waffles`, context: 'product group name' }),
  'Frozen Yogurt': msg({ message: `Frozen Yogurt`, context: 'product group name' }),
  'Fruit Snacks': msg({ message: `Fruit Snacks`, context: 'product group name' }),
  'Fusilli Pasta': msg({ message: `Fusilli Pasta`, context: 'product group name' }),
  Garlic: msg({ message: `Garlic`, context: 'product group name' }),
  Ginger: msg({ message: `Ginger`, context: 'product group name' }),
  Granola: msg({ message: `Granola`, context: 'product group name' }),
  'Granola Bars': msg({ message: `Granola Bars`, context: 'product group name' }),
  'Grape Juice': msg({ message: `Grape Juice`, context: 'product group name' }),
  Grapes: msg({ message: `Grapes`, context: 'product group name' }),
  'Greek Yogurt': msg({ message: `Greek Yogurt`, context: 'product group name' }),
  'Green Beans': msg({ message: `Green Beans`, context: 'product group name' }),
  'Green Onions': msg({ message: `Green Onions`, context: 'product group name' }),
  'Green Tea': msg({ message: `Green Tea`, context: 'product group name' }),
  'Ground Beef': msg({ message: `Ground Beef`, context: 'product group name' }),
  'Ground Coffee': msg({ message: `Ground Coffee`, context: 'product group name' }),
  'Ground Lamb': msg({ message: `Ground Lamb`, context: 'product group name' }),
  'Ground Pork': msg({ message: `Ground Pork`, context: 'product group name' }),
  'Ground Turkey': msg({ message: `Ground Turkey`, context: 'product group name' }),
  'Gummy Candy': msg({ message: `Gummy Candy`, context: 'product group name' }),
  'Half & Half': msg({ message: `Half & Half`, context: 'product group name' }),
  Halibut: msg({ message: `Halibut`, context: 'product group name' }),
  Ham: msg({ message: `Ham`, context: 'product group name' }),
  'Hamburger Buns': msg({ message: `Hamburger Buns`, context: 'product group name' }),
  'Hand Soap': msg({ message: `Hand Soap`, context: 'product group name' }),
  'Hard Seltzer': msg({ message: `Hard Seltzer`, context: 'product group name' }),
  'Heavy Cream': msg({ message: `Heavy Cream`, context: 'product group name' }),
  'Herbal Tea': msg({ message: `Herbal Tea`, context: 'product group name' }),
  'Herbs (Fresh)': msg({ message: `Herbs (Fresh)`, context: 'product group name' }),
  Honey: msg({ message: `Honey`, context: 'product group name' }),
  'Hot Dog Buns': msg({ message: `Hot Dog Buns`, context: 'product group name' }),
  'Hot Dogs': msg({ message: `Hot Dogs`, context: 'product group name' }),
  'Hot Sauce': msg({ message: `Hot Sauce`, context: 'product group name' }),
  'Ice Cream': msg({ message: `Ice Cream`, context: 'product group name' }),
  'Ice Cream Bars': msg({ message: `Ice Cream Bars`, context: 'product group name' }),
  'Iceberg Lettuce': msg({ message: `Iceberg Lettuce`, context: 'product group name' }),
  'Instant Yeast': msg({ message: `Instant Yeast`, context: 'product group name' }),
  'Italian Dressing': msg({ message: `Italian Dressing`, context: 'product group name' }),
  Jalapeños: msg({ message: `Jalapeños`, context: 'product group name' }),
  'Jam / Jelly': msg({ message: `Jam / Jelly`, context: 'product group name' }),
  'Jasmine Rice': msg({ message: `Jasmine Rice`, context: 'product group name' }),
  Kale: msg({ message: `Kale`, context: 'product group name' }),
  Ketchup: msg({ message: `Ketchup`, context: 'product group name' }),
  Kielbasa: msg({ message: `Kielbasa`, context: 'product group name' }),
  Kombucha: msg({ message: `Kombucha`, context: 'product group name' }),
  'Lactose-Free Milk': msg({ message: `Lactose-Free Milk`, context: 'product group name' }),
  'Lamb Chops': msg({ message: `Lamb Chops`, context: 'product group name' }),
  'Lamb Leg': msg({ message: `Lamb Leg`, context: 'product group name' }),
  'Lamb Rack': msg({ message: `Lamb Rack`, context: 'product group name' }),
  'Laundry Detergent': msg({ message: `Laundry Detergent`, context: 'product group name' }),
  Lemonade: msg({ message: `Lemonade`, context: 'product group name' }),
  Lemons: msg({ message: `Lemons`, context: 'product group name' }),
  Limes: msg({ message: `Limes`, context: 'product group name' }),
  'Lip Balm': msg({ message: `Lip Balm`, context: 'product group name' }),
  Lobster: msg({ message: `Lobster`, context: 'product group name' }),
  Mangoes: msg({ message: `Mangoes`, context: 'product group name' }),
  'Maple Syrup': msg({ message: `Maple Syrup`, context: 'product group name' }),
  Mayonnaise: msg({ message: `Mayonnaise`, context: 'product group name' }),
  'Mixed Nuts': msg({ message: `Mixed Nuts`, context: 'product group name' }),
  Moisturizer: msg({ message: `Moisturizer`, context: 'product group name' }),
  Mozzarella: msg({ message: `Mozzarella`, context: 'product group name' }),
  Muffins: msg({ message: `Muffins`, context: 'product group name' }),
  'Multigrain Bread': msg({ message: `Multigrain Bread`, context: 'product group name' }),
  Multivitamins: msg({ message: `Multivitamins`, context: 'product group name' }),
  Mushrooms: msg({ message: `Mushrooms`, context: 'product group name' }),
  Mussels: msg({ message: `Mussels`, context: 'product group name' }),
  'Naan Bread': msg({ message: `Naan Bread`, context: 'product group name' }),
  'Oat Milk': msg({ message: `Oat Milk`, context: 'product group name' }),
  'Oats / Oatmeal': msg({ message: `Oats / Oatmeal`, context: 'product group name' }),
  'Olive Oil': msg({ message: `Olive Oil`, context: 'product group name' }),
  Onions: msg({ message: `Onions`, context: 'product group name' }),
  'Orange Juice': msg({ message: `Orange Juice`, context: 'product group name' }),
  Oranges: msg({ message: `Oranges`, context: 'product group name' }),
  Oysters: msg({ message: `Oysters`, context: 'product group name' }),
  'Pancake Mix': msg({ message: `Pancake Mix`, context: 'product group name' }),
  'Paper Towels': msg({ message: `Paper Towels`, context: 'product group name' }),
  'Parchment Paper': msg({ message: `Parchment Paper`, context: 'product group name' }),
  Parmesan: msg({ message: `Parmesan`, context: 'product group name' }),
  'Pasta Sauce': msg({ message: `Pasta Sauce`, context: 'product group name' }),
  Peaches: msg({ message: `Peaches`, context: 'product group name' }),
  'Peanut Butter': msg({ message: `Peanut Butter`, context: 'product group name' }),
  Peanuts: msg({ message: `Peanuts`, context: 'product group name' }),
  Pears: msg({ message: `Pears`, context: 'product group name' }),
  'Penne Pasta': msg({ message: `Penne Pasta`, context: 'product group name' }),
  Pepperoni: msg({ message: `Pepperoni`, context: 'product group name' }),
  'Pet Food (Cat)': msg({ message: `Pet Food (Cat)`, context: 'product group name' }),
  'Pet Food (Dog)': msg({ message: `Pet Food (Dog)`, context: 'product group name' }),
  'Pie Crusts': msg({ message: `Pie Crusts`, context: 'product group name' }),
  Pineapple: msg({ message: `Pineapple`, context: 'product group name' }),
  'Pita Bread': msg({ message: `Pita Bread`, context: 'product group name' }),
  'Pizza Pockets': msg({ message: `Pizza Pockets`, context: 'product group name' }),
  'Pizza Snacks': msg({ message: `Pizza Snacks`, context: 'product group name' }),
  'Plastic Wrap': msg({ message: `Plastic Wrap`, context: 'product group name' }),
  Popcorn: msg({ message: `Popcorn`, context: 'product group name' }),
  'Pork Chops': msg({ message: `Pork Chops`, context: 'product group name' }),
  'Pork Tenderloin': msg({ message: `Pork Tenderloin`, context: 'product group name' }),
  'Potato Chips': msg({ message: `Potato Chips`, context: 'product group name' }),
  Potatoes: msg({ message: `Potatoes`, context: 'product group name' }),
  Pretzels: msg({ message: `Pretzels`, context: 'product group name' }),
  'Protein Bars': msg({ message: `Protein Bars`, context: 'product group name' }),
  'Protein Powder': msg({ message: `Protein Powder`, context: 'product group name' }),
  'Puff Pastry': msg({ message: `Puff Pastry`, context: 'product group name' }),
  Quinoa: msg({ message: `Quinoa`, context: 'product group name' }),
  'Ramen Noodles': msg({ message: `Ramen Noodles`, context: 'product group name' }),
  'Ranch Dressing': msg({ message: `Ranch Dressing`, context: 'product group name' }),
  Raspberries: msg({ message: `Raspberries`, context: 'product group name' }),
  Razors: msg({ message: `Razors`, context: 'product group name' }),
  'Red Onions': msg({ message: `Red Onions`, context: 'product group name' }),
  'Red Wine': msg({ message: `Red Wine`, context: 'product group name' }),
  'Regular Yogurt': msg({ message: `Regular Yogurt`, context: 'product group name' }),
  'Rice Cakes': msg({ message: `Rice Cakes`, context: 'product group name' }),
  'Rolled Oats': msg({ message: `Rolled Oats`, context: 'product group name' }),
  'Romaine Lettuce': msg({ message: `Romaine Lettuce`, context: 'product group name' }),
  Salami: msg({ message: `Salami`, context: 'product group name' }),
  'Salmon Fillet': msg({ message: `Salmon Fillet`, context: 'product group name' }),
  Salsa: msg({ message: `Salsa`, context: 'product group name' }),
  'Salted Butter': msg({ message: `Salted Butter`, context: 'product group name' }),
  Sardines: msg({ message: `Sardines`, context: 'product group name' }),
  Sausages: msg({ message: `Sausages`, context: 'product group name' }),
  Scallops: msg({ message: `Scallops`, context: 'product group name' }),
  Shampoo: msg({ message: `Shampoo`, context: 'product group name' }),
  Shrimp: msg({ message: `Shrimp`, context: 'product group name' }),
  'Skim Milk': msg({ message: `Skim Milk`, context: 'product group name' }),
  'Sour Cream': msg({ message: `Sour Cream`, context: 'product group name' }),
  'Sourdough Bread': msg({ message: `Sourdough Bread`, context: 'product group name' }),
  'Soy Milk': msg({ message: `Soy Milk`, context: 'product group name' }),
  'Soy Sauce': msg({ message: `Soy Sauce`, context: 'product group name' }),
  Spaghetti: msg({ message: `Spaghetti`, context: 'product group name' }),
  'Sparkling Water': msg({ message: `Sparkling Water`, context: 'product group name' }),
  Spinach: msg({ message: `Spinach`, context: 'product group name' }),
  'Sports Drinks': msg({ message: `Sports Drinks`, context: 'product group name' }),
  Sriracha: msg({ message: `Sriracha`, context: 'product group name' }),
  'Stew Beef': msg({ message: `Stew Beef`, context: 'product group name' }),
  Strawberries: msg({ message: `Strawberries`, context: 'product group name' }),
  Sunscreen: msg({ message: `Sunscreen`, context: 'product group name' }),
  'Sweet Potatoes': msg({ message: `Sweet Potatoes`, context: 'product group name' }),
  'Swiss Cheese': msg({ message: `Swiss Cheese`, context: 'product group name' }),
  Tilapia: msg({ message: `Tilapia`, context: 'product group name' }),
  'Toilet Paper': msg({ message: `Toilet Paper`, context: 'product group name' }),
  'Tomato Paste': msg({ message: `Tomato Paste`, context: 'product group name' }),
  'Tomato Sauce': msg({ message: `Tomato Sauce`, context: 'product group name' }),
  Tomatoes: msg({ message: `Tomatoes`, context: 'product group name' }),
  Toothbrush: msg({ message: `Toothbrush`, context: 'product group name' }),
  Toothpaste: msg({ message: `Toothpaste`, context: 'product group name' }),
  'Tortilla Chips': msg({ message: `Tortilla Chips`, context: 'product group name' }),
  Tortillas: msg({ message: `Tortillas`, context: 'product group name' }),
  'Trail Mix': msg({ message: `Trail Mix`, context: 'product group name' }),
  'Trash Bags': msg({ message: `Trash Bags`, context: 'product group name' }),
  'Tuna Steak': msg({ message: `Tuna Steak`, context: 'product group name' }),
  'Turkey Breast': msg({ message: `Turkey Breast`, context: 'product group name' }),
  'Unsalted Butter': msg({ message: `Unsalted Butter`, context: 'product group name' }),
  'Vanilla Extract': msg({ message: `Vanilla Extract`, context: 'product group name' }),
  'Vegetable Oil': msg({ message: `Vegetable Oil`, context: 'product group name' }),
  'Veggie Burgers': msg({ message: `Veggie Burgers`, context: 'product group name' }),
  'Vitamins & Supplements': msg({
    message: `Vitamins & Supplements`,
    context: 'product group name',
  }),
  Water: msg({ message: `Water`, context: 'product group name' }),
  Watermelon: msg({ message: `Watermelon`, context: 'product group name' }),
  'Whipping Cream': msg({ message: `Whipping Cream`, context: 'product group name' }),
  'White Rice': msg({ message: `White Rice`, context: 'product group name' }),
  'White Sandwich Bread': msg({ message: `White Sandwich Bread`, context: 'product group name' }),
  'White Sugar': msg({ message: `White Sugar`, context: 'product group name' }),
  'White Vinegar': msg({ message: `White Vinegar`, context: 'product group name' }),
  'White Wine': msg({ message: `White Wine`, context: 'product group name' }),
  'Whole Chicken': msg({ message: `Whole Chicken`, context: 'product group name' }),
  'Whole Milk': msg({ message: `Whole Milk`, context: 'product group name' }),
  'Whole Wheat Bread': msg({ message: `Whole Wheat Bread`, context: 'product group name' }),
  Wine: msg({ message: `Wine`, context: 'product group name' }),
  'Worcestershire Sauce': msg({ message: `Worcestershire Sauce`, context: 'product group name' }),
  'Yellow Mustard': msg({ message: `Yellow Mustard`, context: 'product group name' }),
  'Zip-Lock Bags': msg({ message: `Zip-Lock Bags`, context: 'product group name' }),
  Zucchini: msg({ message: `Zucchini`, context: 'product group name' }),
};

// ---------------------------------------------------------------------------
// Helper — translate a product group name at runtime
// ---------------------------------------------------------------------------

/**
 * Translates a product group name using the i18n registry.
 * Falls back to the raw name if no translation is registered
 * (e.g. for custom user-created groups).
 */
export function translateGroupName(i18n: I18n, name: string): string {
  const descriptor = productGroupMessages[name];
  return descriptor ? i18n._(descriptor) : name;
}
